var React = require('react');

function ArrowAltFromRight (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M448 88v336a23.94 23.94 0 0 1-24 24h-16a23.94 23.94 0 0 1-24-24V88a23.94 23.94 0 0 1 24-24h16a23.94 23.94 0 0 1 24 24z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M352 215.89V296a24 24 0 0 1-24 24H192v88c0 17.82-21.51 26.73-34.11 14.12L5.63 269.67a19.4 19.4 0 0 1 0-27.34L157.86 89.91C170.46 77.3 192 86.21 192 104v87.83h136a24 24 0 0 1 24 24.06z","className":"fa-primary","key":2})]);
}

ArrowAltFromRight.defaultProps = {"viewBox":"0 0 448 512","className":"icon"};

module.exports = ArrowAltFromRight;

ArrowAltFromRight.default = ArrowAltFromRight;
